import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TitleService } from '../../common/services/title/title.service';
import { INavigationItem } from '../types/inavigation-item';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    public showInsights = false;

    public navigations: INavigationItem[] = [
        {
            url: '/home',
            name: 'Home',
            icon: 'home',
            isVisible: () => true,
        },
        {
            url: '/places',
            name: 'Places',
            icon: 'place',
            isVisible: () => true,
        },
        {
            url: '/insights',
            name: 'Insights',
            icon: 'insights',
            isVisible: () => true,
        },
        {
            url: '/notifications',
            name: 'Notifications',
            icon: 'notifications',
            isVisible: () => true,
        },
        {
            url: '/controlAudits',
            name: 'Control Audits',
            icon: 'build',
            isVisible: () => true,
            isHiddenOnBottomSection: true
        },
        {
            url: '/help',
            name: 'Help',
            icon: 'help',
            isVisible: () => true,
            isHiddenOnBottomSection: true
        }
    ];

    constructor(
        private titleService: TitleService,
        private router: Router
    ) {
    }

    public navigate(navigation: INavigationItem) {
        if (navigation.clickHandler) {
            return navigation.clickHandler();
        }

        this.titleService.title = navigation.name;

        this.router.navigateByUrl(navigation.url, {skipLocationChange: navigation.skipLocationChange});
    }
}
